import "./Cart.module.css";
import MainIndustrialHeader from "@/reusable_sections/Header";
import CartContent from "./sections/CartContent";
import IndustrialFooter from "@/reusable_sections/Footer";
export default function CartPage() {
  return <div>
      <MainIndustrialHeader />
      <CartContent />
      <IndustrialFooter />
    </div>;
}